require('./brokerQuotesSearchView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { connect } = require('react-redux');

const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

const BrokerSearch = require('components/broker/brokerSearch/brokerSearch');
const BrokerSearchAction = require('actions/brokerSearch');
const BrokerAd = require('components/commons/broker/ads/brokerAd');
const { ContentBox } = require('commonsComponents/contentBox');

class BrokerQuotesSearchView extends React.Component {
    render() {
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-quotesSearch'),
                url: ''
            }
        ];

        return (
            <div className="broker-quotes-search-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-quotesSearch')}
                    />
                </OKCover>
                <section className="broker-quotes-search-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <ContentBox
                                title={formatText('breadcrumb-quotesSearch')}
                                icon="wallet"
                            >
                                <iframe
                                    className="broker-quotes-search-view__search_iframe"
                                    frameBorder="0"
                                    width="100%"
                                    height=""
                                    scrolling="no"
                                    src=""
                                />
                            </ContentBox>
                        </div>
                        <div className="col-xs-4">
                            <div className="broker-quotes-search-view__searchbox">
                                <BrokerSearch
                                    onHandleSearch={this.props.handleSearchProduct}
                                    onHandleSearchReset={this.props.handleSearchReset}
                                    searchState={this.props.searchProducts}
                                />
                            </div>
                            <BrokerAd
                                myName="Deposito combinado DUO" //@hardcoded
                                introText="La tranquilidad de un depósito bancario y las ventajas de un fondo de inversión." //@hardcoded
                                backgroundUrl="http://res.cloudinary.com/repunck/image/upload/v1469815564/inlovecouple_fx1kxx.jpg" //@hardcoded
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerQuotesSearchView.propTypes = {
    handleSearchProduct: PropTypes.func,
    handleSearchReset: PropTypes.func,
    searchProducts: PropTypes.object,
}

module.exports.constructor = BrokerQuotesSearchView;
module.exports.BrokerQuotesSearchView = connect(
    state => ({
        searchProducts: state.brokerSearch,
    }), {
        handleSearchProduct: BrokerSearchAction.searchProduct,
        handleSearchReset: BrokerSearchAction.clearResults
    })(BrokerQuotesSearchView);